import { QuantityInput, QuantityInputPropsType } from '@appclose/ui';

import field, { FiledPropsType } from '../../../../hoc/field';

export default function QuantityField(
  props: FiledPropsType<QuantityInputPropsType>
) {
  return field(props)(QuantityInput);
}
